import React, {PureComponent} from 'react';

import {MuiThemeProvider, createMuiTheme, withStyles} from '@material-ui/core/styles/index';
import {blue, pink, grey} from '@material-ui/core/colors';


import {library} from '@fortawesome/fontawesome-svg-core/index'
import {faTimes} from '@fortawesome/pro-light-svg-icons/faTimes'
import {faSave} from '@fortawesome/pro-light-svg-icons/faSave'
import {faPlus} from '@fortawesome/pro-light-svg-icons/faPlus'
import {faCog} from '@fortawesome/pro-light-svg-icons/faCog'
import {faRedo} from '@fortawesome/pro-light-svg-icons/faRedo'
import {faArrowLeft} from '@fortawesome/pro-light-svg-icons/faArrowLeft'
import {faLink} from '@fortawesome/pro-light-svg-icons/faLink'
import {faTrash} from '@fortawesome/pro-light-svg-icons/faTrash'
import {faPencil} from '@fortawesome/pro-light-svg-icons/faPencil'
import {faUnlink} from '@fortawesome/pro-light-svg-icons/faUnlink'
import {faMagic} from '@fortawesome/pro-light-svg-icons/faMagic'
import {faSpinner} from '@fortawesome/pro-light-svg-icons/faSpinner'
import {faBold} from '@fortawesome/pro-solid-svg-icons/faBold'
import {faPencilAlt} from '@fortawesome/pro-solid-svg-icons/faPencilAlt'
import {faCheck} from '@fortawesome/pro-light-svg-icons/faCheck'
import {faBars} from '@fortawesome/pro-light-svg-icons/faBars'
import {faSpinnerThird} from '@fortawesome/pro-light-svg-icons/faSpinnerThird'
import {faEllipsisV} from '@fortawesome/pro-light-svg-icons/faEllipsisV'
import {faInfo} from '@fortawesome/pro-light-svg-icons/faInfo'
import {faChartLine} from '@fortawesome/pro-light-svg-icons/faChartLine'
import {faClipboardListCheck} from '@fortawesome/pro-light-svg-icons/faClipboardListCheck'
import {faCrown} from '@fortawesome/pro-light-svg-icons/faCrown'
import {faFolderOpen} from '@fortawesome/pro-light-svg-icons/faFolderOpen'
import {faQuestionCircle} from '@fortawesome/pro-light-svg-icons/faQuestionCircle'
import {faBadgePercent} from '@fortawesome/pro-light-svg-icons/faBadgePercent'
import {faBookReader} from '@fortawesome/pro-light-svg-icons/faBookReader'
import {faUserHeadset} from '@fortawesome/pro-light-svg-icons/faUserHeadset'
import {faSignOut} from '@fortawesome/pro-light-svg-icons/faSignOut'
import {faFileSignature} from '@fortawesome/pro-light-svg-icons/faFileSignature'
import {faEye} from '@fortawesome/pro-light-svg-icons/faEye'
import {faFileContract} from '@fortawesome/pro-light-svg-icons/faFileContract'
import {faChevronDown} from '@fortawesome/pro-light-svg-icons/faChevronDown'
import {faPaperPlane} from '@fortawesome/pro-light-svg-icons/faPaperPlane'
import {faCheckDouble} from '@fortawesome/pro-light-svg-icons/faCheckDouble'
import {faUser} from '@fortawesome/pro-light-svg-icons/faUser'
import {faAnalytics} from '@fortawesome/pro-light-svg-icons/faAnalytics'
import {faLevelUp} from '@fortawesome/pro-light-svg-icons/faLevelUp'
import {faMousePointer} from '@fortawesome/pro-light-svg-icons/faMousePointer'
import {faTimesCircle} from '@fortawesome/pro-light-svg-icons/faTimesCircle'
//import {far} from '@fortawesome/pro-regular-svg-icons'
//import {fas} from '@fortawesome/pro-solid-svg-icons'
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";
import AdminPanelView from "./views/AdminPanelView";
import axios from 'axios'
import queryString from 'query-string'
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import IconButton from "@material-ui/core/IconButton";
import CssBaseline from "@material-ui/core/CssBaseline";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Divider from "@material-ui/core/Divider";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import classNames from 'classnames';
import Drawer from "@material-ui/core/Drawer";
import Hidden from "@material-ui/core/Hidden";
import moment from "./components/Filters/TableFilters/AdminFilterForm";
import {HashRouter} from 'react-router-dom'
import {Switch, Route, Redirect, Router} from 'react-router'
import AdminProjectSettings from "./views/AdminProjectSettings";
import {getMetaData, login, loginAsUser, logout, relogWithToken} from "./api";
import ApplicationChatBot from "./components/ApplicationChatBot/ApplicationChatBot";
import ChatBot from "./components/ChatBot/ChatBot";
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import AdminDashboard from "./views/AdminDashboard";

library.add(faTimes, faSave, faPlus, faCog, faArrowLeft, faLink, faTrash, faPencil, faUnlink, faMagic, faSpinner, faBold, faPencilAlt, faCheck, faBars, faSpinnerThird, faEllipsisV, faInfo,
    faChartLine, faClipboardListCheck, faCrown, faFolderOpen, faQuestionCircle, faBadgePercent, faBookReader, faUserHeadset, faSignOut, faRedo, faFileSignature, faEye, faFileContract, faChevronDown, faPaperPlane, faCheckDouble, faUser, faAnalytics, faLevelUp, faMousePointer, faTimesCircle)

// Generate breakpoints so we can use them in the theme definition
const breakpoints = createBreakpoints({});
const theme = createMuiTheme({
    typography: {
        useNextVariants: true,
    },
    palette: {
        primary: blue,
        secondary: pink,
    },
    breakpoints,
    overrides: {
        MuiTypography: {}
    }
});
const drawerWidth = 240;

const styles = theme => ({
    root: {
        display: 'flex',
    },
    menuButton: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    openMenuButton: {
        marginLeft: 0,
        [theme.breakpoints.up('md')]: {
            marginLeft: -theme.spacing(1),
        }
    },
    title: {
        flexGrow: 1,
        color: '#fff'
    },
    appBar: {
        backgroundColor: 'white',
        color: 'rgba(0,0,0,0.81)',
        borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
        [theme.breakpoints.up('md')]: {
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
        }
    },
    appBarShift: {
        [theme.breakpoints.up('md')]: {
            width: `calc(100% - ${drawerWidth}px)`,
            marginLeft: drawerWidth,
            transition: theme.transitions.create(['margin', 'width'], {
                easing: theme.transitions.easing.easeOut,
                duration: theme.transitions.duration.enteringScreen,
            }),
        }
    },
    hide: {
        display: 'none',
    },
    drawer: {
        width: drawerWidth,
        flexShrink: 0,
    },
    drawerPaper: {
        width: drawerWidth,
    },
    drawerHeader: {
        display: 'flex',
        alignItems: 'center',
        padding: '0 8px',
        ...theme.mixins.toolbar,
        justifyContent: 'center',
        textAlign: 'center'
    },
    logoText: {
        fontSize: '26px',
        marginLeft: '8px',
        textTransform: 'uppercase',
    },
    content: {
        flexGrow: 1,
        maxWidth: '100%',
        padding: theme.spacing(2) + 'px ' + theme.spacing(1) + 'px',
        [theme.breakpoints.up('md')]: {
            padding: theme.spacing(3),
            transition: theme.transitions.create('margin', {
                easing: theme.transitions.easing.sharp,
                duration: theme.transitions.duration.leavingScreen,
            }),
            marginLeft: -drawerWidth,
        }
    },
    contentShift: {
        transition: theme.transitions.create('margin', {
            easing: theme.transitions.easing.easeOut,
            duration: theme.transitions.duration.enteringScreen,
        }),
        marginLeft: 0,
        [theme.breakpoints.up('md')]: {
            maxWidth: 'calc(100% - ' + drawerWidth + 'px)',
        }
    },
    listIcon: {
        width: 15,
        color: 'rgba(0, 0, 0, 0.7)'
    },
    formControl: {
        width: '100%',
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
    },
    selectInput: {
        marginTop: 0
    },
    grow: {
        flexGrow: 1,
    },
    userName: {
        [theme.breakpoints.down('sm')]: {
            display: 'none'
        }
    }
});

class AutoPanel extends PureComponent {

    constructor(props) {
        super(props);

        const open = this.getDocumentWidth() < 960 ? false : true

        this.state = {
            open: open,
            latestDocumentWidth: null,
            pageTitle: '',
            sidebarToggled: false,
            loginAsUserId: -1,
            loginableUsers: [],
            user: null,
        };
    }

    updateDimensions = () => {
        const width = this.getDocumentWidth()
        if (!this.state.latestDocumentWidth) {
            this.updateDrawerState(width)
        }
        if (this.state.latestDocumentWidth >= 960 && width < 960) {
            this.updateDrawerState(width)
        }
        if (this.state.latestDocumentWidth < 960 && width >= 960) {
            this.updateDrawerState(width)
        }
    }

    updateDrawerState = (width) => {
        if (this.state.sidebarToggled) {
            this.setState({sidebarToggled: false, latestDocumentWidth: width});
        } else {
            if (width < 960) {
                this.setState({open: false, latestDocumentWidth: width});
            } else {
                this.setState({open: true, latestDocumentWidth: width});
            }
        }
    }

    setPageTitle = (pageTitle) => {
        this.setState({pageTitle: pageTitle});
    }

    componentDidMount() {
        window.addEventListener("resize", this.updateDimensions);
        getMetaData().then((res) => {
            this.setState({loginableUsers: res.users, user: res.user})
            this.setUser(res.user)
        })
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.updateDimensions);
    }

    handleDrawerToggle = () => {
        this.setState({open: !this.state.open, mobileOpen: !this.state.mobileOpen, sidebarToggled: true});
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 100)
    };

    applicationDataSrc = (filters, viewType) => {

        const qStr = `?${queryString.stringify(filters)}&ts=${Date.now()}`
        return axios.get(this.props.src + '/application' + qStr);
    }

    applicationInitSrc = (filters, viewType) => {
        const qStr = `?${queryString.stringify(filters)}&ts=${Date.now()}`
        return axios.get(this.props.src + '/application/init' + qStr);
    }

    visitorDataSrc = (filters, viewType) => {

        const qStr = `?${queryString.stringify(filters)}&ts=${Date.now()}`
        return axios.get(this.props.src + '/visitor' + qStr);
    }

    visitorInitSrc = (filters, viewType) => {
        const qStr = `?${queryString.stringify(filters)}&ts=${Date.now()}`
        return axios.get(this.props.src + '/visitor/init' + qStr);
    }

    dashboardSrc = (segments, from, to) => {
        const qStr = `?segments=${JSON.stringify(segments)}&from=${from.format('YYYY-MM-DD')}&to=${to.format('YYYY-MM-DD')}&ts=${Date.now()}`
        return axios.get(this.props.src + '/dashboard' + qStr);
    }

    getDrawerVariant() {
        if (this.getDocumentWidth() < 960) {
            return 'temporary'
        } else {
            return 'persistent'
        }
    }

    getDocumentWidth() {
        return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    }

    updateLocation = (href) => {
        const currentLocation = window.location.search + window.location.hash
        if (href === currentLocation) {
            window.location.reload()
        }
    }

    onLogout = () => {
        logout()
    }

    setUser = (user) => {
        this.setState({user: user})
    }

    clickEventHandler = (event) => {
    }

    onLoginAsUser = (event) => {
        const loginAsUserId = event.target.value
        this.setState({loginAsUserId: loginAsUserId})
        loginAsUser(loginAsUserId).then((res) => relogWithToken(res.token))
    }

    render() {
        const {classes} = this.props;
        const {open, pageTitle, user, loginAsUserId, loginableUsers} = this.state;

        const drawer = (
            <>
                <div className={classes.drawerHeader}>
                    <img src="/img/logo-tarjous@2x.png" style={{maxWidth: '70%'}}/>
                </div>
                <Divider/>
                <List>
                    {user && user.type === 'admin' && <>
                        {[
                            {label: 'Hallintapaneeli', icon: 'analytics', url: '?dashboard#dashboard'},
                            {label: 'Kävijät', icon: 'book-reader', url: '?visitors#visitors'},
                        ].map((value, index) => (
                            <ListItem button key={value.label} component="a" href={value.url}
                                      onClick={() => this.updateLocation(value.url)}>
                                <ListItemIcon className={classes.listIcon}><FontAwesomeIcon size="lg"
                                                                                            icon={['fal', value.icon]}/></ListItemIcon>
                                <ListItemText primary={value.label}/>
                            </ListItem>
                        ))}
                    </>}
                    {[
                        {label: 'Hakemukset', icon: 'file-signature', url: '?applications#applications'},
                    ].map((value, index) => (
                        <ListItem button key={value.label} component="a" href={value.url}
                                  onClick={() => this.updateLocation(value.url)}>
                            <ListItemIcon className={classes.listIcon}><FontAwesomeIcon size="lg"
                                                                                        icon={['fal', value.icon]}/></ListItemIcon>
                            <ListItemText primary={value.label}/>
                        </ListItem>
                    ))}
                </List>
                <Divider/>
                {user && user.type === 'admin' && <>
                    <List>
                        {[
                            {
                                label: 'Question Pages',
                                icon: 'crown',
                                url: '?itemType=QuestionContainer&action=edit&id=1#project-settings'
                            },
                            {
                                label: 'Question Page Groups',
                                icon: 'folder-open',
                                url: '?itemType=QuestionPageGroup&action=list#project-settings'
                            },
                            {
                                label: 'Questions',
                                icon: 'question-circle',
                                url: '?itemType=Question&action=list#project-settings'
                            },
                            {
                                label: 'Scoring Objects',
                                icon: 'badge-percent',
                                url: '?itemType=ScoringObject&action=list#project-settings'
                            },
                            {
                                label: 'Clients',
                                icon: 'book-reader',
                                url: '?itemType=Client&action=list#project-settings'
                            },
                        ].map((value, index) => (
                            <ListItem button key={value.label} component="a" href={value.url}
                                      onClick={() => this.updateLocation(value.url)}>
                                <ListItemIcon className={classes.listIcon}><FontAwesomeIcon size="lg"
                                                                                            icon={['fal', value.icon]}/></ListItemIcon>
                                <ListItemText primary={value.label}/>
                            </ListItem>
                        ))}
                    </List>
                    <Divider/>
                    <List>
                        <ListItem button key={'user-select'} component="div">
                            <ListItemIcon className={classes.listIcon}><FontAwesomeIcon size="lg"
                                                                                        icon={['fal', 'user']}/></ListItemIcon>
                            <FormControl className={classes.formControl}>
                                <Select
                                    classes={{root: classes.selectInput}}
                                    value={loginAsUserId}
                                    onChange={this.onLoginAsUser}
                                    inputProps={{
                                        name: 'age',
                                        id: 'age-simple',
                                    }}
                                >
                                    <MenuItem value={-1} disabled={true}>
                                        <em>Login as User...</em>
                                    </MenuItem>
                                    {loginableUsers.map((user, key) =>
                                        <MenuItem value={user.id}>{user.name}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </ListItem>
                    </List>
                    <Divider/>
                </>
                }
                <List>
                    {[
                        {label: 'Kirjaudu ulos', icon: 'sign-out'}
                    ].map((value, index) => (
                        <ListItem button key={value.label} onClick={this.onLogout}>
                            <ListItemIcon className={classes.listIcon}><FontAwesomeIcon size="lg"
                                                                                        icon={['fal', value.icon]}/></ListItemIcon>
                            <ListItemText primary={value.label}/>
                        </ListItem>
                    ))}
                </List>
            </>
        )
        return (
            <>
                <MuiThemeProvider theme={theme}>
                    <div className={classes.root}>
                        <CssBaseline/>
                        <AppBar
                            elevation={0}
                            position="fixed"
                            className={classNames(classes.appBar, {
                                [classes.appBarShift]: open,
                            })}
                        >
                            <Toolbar disableGutters={!open}>
                                <IconButton
                                    color="inherit"
                                    aria-label="Open drawer"
                                    onClick={this.handleDrawerToggle}
                                    className={classNames(classes.menuButton, open && classes.openMenuButton)}
                                >
                                    <FontAwesomeIcon size="sm" icon={['fal', 'bars']}/>
                                </IconButton>
                                <Typography variant="h6" color="inherit" noWrap className={classes.grow}>
                                    {pageTitle}
                                </Typography>
                                {user && <Button color="inherit" className={classes.userName}>{user.name}</Button>}
                            </Toolbar>
                        </AppBar>
                        <Hidden implementation="css">
                            <Drawer
                                className={classes.drawer}
                                variant={this.getDrawerVariant()}
                                onClose={this.handleDrawerToggle}
                                anchor="left"
                                open={open}
                                classes={{
                                    paper: classes.drawerPaper,
                                }}
                            >
                                {drawer}
                            </Drawer>
                        </Hidden>
                        <main
                            className={classNames(classes.content, {
                                [classes.contentShift]: open,
                            })}
                        >
                            <div className={classes.drawerHeader}/>
                            <HashRouter hashType="noslash">
                                <Switch>
                                    <Redirect exact from="/" to="/applications"/>
                                    <Route exact path="/applications">
                                        <AdminPanelView initSrc={this.applicationInitSrc}
                                                        dataSrc={this.applicationDataSrc}
                                                        setUser={this.setUser} title={'Hakemukset'}
                                                        setPageTitle={this.setPageTitle}/>
                                    </Route>
                                    <Route exact path="/visitors">
                                        <AdminPanelView initSrc={this.visitorInitSrc} dataSrc={this.visitorDataSrc}
                                                        setUser={this.setUser} title={'Kävijät'}
                                                        setPageTitle={this.setPageTitle}/>
                                    </Route>
                                    <Route exact path="/project-settings">
                                        <AdminProjectSettings initSrc={this.initSrc} setPageTitle={this.setPageTitle}/>
                                    </Route>
                                    <Route exact path="/dashboard">
                                        <AdminDashboard initSrc={this.dashboardSrc} setPageTitle={this.setPageTitle}/>
                                    </Route>
                                    <Route exact path="/chat">
                                        <ApplicationChatBot eventHandler={this.clickEventHandler}/>
                                        <ChatBot/>
                                    </Route>
                                </Switch>
                            </HashRouter>

                        </main>
                    </div>
                </MuiThemeProvider>
            </>
        );
    }
}

export default withStyles(styles)(AutoPanel);
